import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { filter } from 'rxjs/operators';

import { RegisterService } from '../register/register.service';

@Component({
  selector: 'cutting-activate-account',
  templateUrl: './activate-account.component.html',
  styleUrls: ['./activate-account.component.scss'],
  animations: fuseAnimations,
})
export class ActivateAccountComponent implements OnInit {
  userOrign: string;

  constructor(
    private fuseConfigService: FuseConfigService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private registerService: RegisterService
  ) {
    this.fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.pipe(filter(params => params.key || params.userOrign)).subscribe(params => {
      if (params.userOrign) {
        this.userOrign = atob(params.userOrign);
      }

      if (params.key !== undefined && params.key !== '') {
        this.registerService.activateClientByKey(params.key).subscribe(null, () => {
          this.router.navigate(['/']);
        });
      }
    });
  }
}
